export const StatusTask = {
    TaskCreated: 0,
    TaskSent: 1,
    TaskReceived: 2,
    TaskAct: 3,
    TaskFinish: 4,
    TaskDelete: 5,
}
